// extracted by mini-css-extract-plugin
export default {"content":"bla-z","title":"cla-z","subTitle":"dla-z","banner":"ela-z","productCardOverride":"fla-z"};